// Mirror of the backend heuristic (functions/api/chat.ts needsWeb) so the UI can
// show a "searching the web…" status for the same questions the backend routes
// to live web search. Kept in sync by hand — it's only cosmetic if it drifts.
const WEB_PATTERNS: RegExp[] = [
  /\b(score|scores|won|winning|beat|lost|game|match|vs\.?|playoff|standings|schedule|fixture|lineup|nba|nfl|mlb|nhl|premier league|la ?liga|world cup|super bowl|championship|tournament)\b/i,
  /\b(latest|today|tonight|right now|current(ly)?|recent(ly)?|this (week|month|year|morning|evening)|breaking|headline|news|as of|so far)\b/i,
  /\b(price|stock|share price|market|weather|forecast|temperature|exchange rate|release date)\b/i,
  /\b(who (won|is winning|leads|scored)|what (happened|is happening)|what'?s happening|when (is|does|did|will|do))\b/i,
];

export function needsWeb(text: string): boolean {
  return WEB_PATTERNS.some((re) => re.test(text));
}
